import { Joi, objectSchemaOf } from '../helpers';

export interface ISlots {
  staffFirstName?: string;
  staffLastName?: string;
  visitorFirstName?: string;
  visitorLastName?: string;
  matchedStaffId?: string;
  requiresSignature?: boolean;
  companyName?: string;
}

export type Slots = ISlots & Record<string, boolean | string | undefined>;

export const slotsSchema = objectSchemaOf<Slots>({
  staffFirstName: Joi.string(),
  staffLastName: Joi.string(),
  visitorFirstName: Joi.string(),
  visitorLastName: Joi.string(),
  matchedStaffId: Joi.string(),
  requiresSignature: Joi.boolean(),
  companyName: Joi.string(),
}).pattern(Joi.string(), Joi.string().required());

export type NLPContext = string[];

export const nlpContextSchema = Joi.array().items(Joi.string());
